import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                if (active) setUser(data);
            } catch {
                if (active) setUser(null);
            }
        })();
        return () => { active = false; };
    }, []);

    async function login(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        if (data?.token) localStorage.setItem("licito_token", data.token);
        // Recarrega o /me para garantir que o flag must_change_password venha completo
        try {
            const me = await api.get("/auth/me");
            setUser(me.data);
            return { ...data, user: me.data };
        } catch {
            setUser(data.user);
            return data;
        }
    }

    async function logout() {
        try { await api.post("/auth/logout"); } catch (_) { /* noop */ }
        localStorage.removeItem("licito_token");
        setUser(null);
    }

    async function refreshUser() {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            return null;
        }
    }

    return (
        <AuthContext.Provider value={{ user, login, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
